import __base_store from '@/store/__base_store'

/**
 * Store de vendedores.
 */
export default __base_store({
	state: {
		model_name: 'seller',
		per_page: 25,
	},
})

